module.exports = __webpack_public_path__ + "img/yj_no_reward_icon.bb6884ad.png";